import classNames from 'classnames';
import React from 'react';
import type { DropdownIndicatorProps, GroupBase } from 'react-select';
import * as styles from './ButtonSelect.module.scss';
import Caret from './Caret';
import type { OptionTypeBase } from './Select';
import Select from './Select';

const DropdownIndicator = <
  OptionType = unknown,
  IsMulti extends boolean = false,
>(
  props: DropdownIndicatorProps<OptionType, IsMulti>,
) => {
  return (
    <div className={styles.dropdownIndicator}>
      <Caret direction={props.selectProps.menuIsOpen ? 'up' : 'down'} />
    </div>
  );
};

type ButtonSelectProps<
  OptionType extends OptionTypeBase = { label: string; value: string },
  IsMulti extends boolean = false,
  IsSimpleValue extends boolean = true,
  GroupType extends GroupBase<OptionType> = GroupBase<OptionType>,
  IsClearable extends boolean = false,
> = React.ComponentProps<
  typeof Select<OptionType, IsMulti, IsSimpleValue, GroupType, IsClearable>
>;

const ButtonSelect = <
  OptionType extends OptionTypeBase = { label: string; value: string },
  IsMulti extends boolean = false,
  IsSimpleValue extends boolean = true,
  GroupType extends GroupBase<OptionType> = GroupBase<OptionType>,
  IsClearable extends boolean = false,
>({
  className,
  components,
  ...rest
}: ButtonSelectProps<
  OptionType,
  IsMulti,
  IsSimpleValue,
  GroupType,
  IsClearable
>) => {
  return (
    <Select
      className={classNames(styles.select, className)}
      components={{
        ...components,
        DropdownIndicator,
      }}
      {...rest}
    />
  );
};

export default ButtonSelect;
